import { Tooltip } from "antd";
import { HTMLAttributes } from "react";
import { Backend } from "shared-types";

export interface AnalyzeViewProps extends HTMLAttributes<HTMLDivElement> {
    data?: Backend.T_AudioMetaData;
    fileName?: string;
}

const overflowDot = 'tw-whitespace-nowrap tw-overflow-x-hidden tw-text-ellipsis tw-max-w-full';

const AnalyzeView = (props: AnalyzeViewProps) => {
    const { data, fileName, className, ...rest } = props;
    return (
        <div className={`tw-flex tw-flex-col tw-space-y-2 tw-items-center tw-select-none ${className ? className : ""}`} {...rest}>
            <Tooltip placement="top" title={fileName}>
                <h3 className={`!tw-text-white !tw-mb-0 !tw-font-extrabold ${overflowDot}`}>{fileName}</h3>
            </Tooltip>
            <Tooltip placement="top" title={data?.Title || "N/A"}>
                <h6 className={`!tw-text-white ${overflowDot}`}><span className="!tw-font-extrabold">Title : </span>{data?.Title || "N/A"}</h6>
            </Tooltip>
            <Tooltip placement="top" title={data?.Artist || "N/A"}>
                <h6 className={`!tw-text-white ${overflowDot}`}><span className="!tw-font-extrabold">Artist : </span>{data?.Artist || "N/A"}</h6>
            </Tooltip>
            <Tooltip placement="top" title={data?.Composer || "N/A"}>
                <h6 className={`!tw-text-white ${overflowDot}`}><span className="!tw-font-extrabold">Composer : </span>{data?.Composer || `N/A`}</h6>
            </Tooltip>
        </div>
    )
}

export default AnalyzeView;